// import './App.css';
// import React, { useEffect, useState } from 'react'
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Navbar from './components/Navbar';
// import News from './components/News';
// import About from './components/About';
// import NewsyDoozy from './components/NewsyDoozy';
// import LoadingBar from 'react-top-loading-bar';

// function App() {
//   const [mode, setMode] = useState("primary");
//   const [navBtnName, setNavBtnName] = useState("Enable Dark Mode");
//   const [progress, setProgress] = useState(0);

//   const toggleMode = () => {
//     if (mode === "primary") {
//       setMode("dark");
//       setNavBtnName("Enable Light Mode");
//       document.body.style.backgroundColor = "#484747";
//       document.body.style.color = "white";
//     }
//     else {
//       setMode("primary");
//       setNavBtnName("Enable Dark Mode");
//       document.body.style.backgroundColor = "white";
//       document.body.style.color = "black";
//     }
//   }
//   useEffect(() => {
//     const storedName = sessionStorage.getItem('username');
//     if (!storedName) {
//       let name = '';
//       while (!name || name.length > 17) {
//         name = prompt('Please Enter Your Name (up to 17 characters):');
//         if (name && name.length > 17) {
//           alert('Please enter a name with up to 17 characters.');
//         }
//       }
//       if (name) {
//         const capitalizedFullName = name
//           .split(' ')
//           .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//           .join(' ');

//         sessionStorage.setItem('username', capitalizedFullName);
//       }
//     }
//   }, []);

//   const pageSize = 12;
//   const apiKey = process.env.REACT_APP_NEWS_API

//   return (
//     <>
//       <Router>
//         <Navbar mode={mode} toggleMode={toggleMode} navBtnName={navBtnName} />
//         <LoadingBar
//           color='#f11946'
//           height={4}
//           progress={progress}
//         // onLoaderFinished={() => setProgress(0)}
//         />
//         <Routes>
//           <Route path="/newsydoozy" element={<NewsyDoozy key="newsydoozy" tabTitle="original" borderColor={mode === "primary" ? "#007BFF" : "black"} mode={mode} />}></Route>
//           <Route path="/" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="general/" tabTitle="original" pageSize={pageSize} country="in" category="general" />}></Route>
//           <Route path="/home" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="generalhome" tabTitle="original" pageSize={pageSize} country="in" category="general" />}></Route>
//           <Route path="/business" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="business" tabTitle="acctocategory" pageSize={pageSize} country="in" category="business" />}></Route>
//           <Route path="/entertainment" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="entertainment" tabTitle="acctocategory" pageSize={pageSize} country="in" category="entertainment" />}></Route>
//           <Route path="/general" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="general" tabTitle="acctocategory" pageSize={pageSize} country="in" category="general" />}></Route>
//           <Route path="/health" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="health" tabTitle="acctocategory" pageSize={pageSize} country="in" category="health" />}></Route>
//           <Route path="/science" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="science" tabTitle="acctocategory" pageSize={pageSize} country="in" category="science" />}></Route>
//           <Route path="/sports" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="sports" tabTitle="acctocategory" pageSize={pageSize} country="in" category="sports" />}></Route>
//           <Route path="/technology" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="technology" tabTitle="acctocategory" pageSize={pageSize} country="in" category="technology" />}></Route>
//           <Route path="/about" element={<About mode={mode} />}></Route>
//         </Routes>
//       </Router>
//     </>
//   )
// }

// export default App;





import './App.css';
import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import News from './components/News';
import About from './components/About';
import NewsyDoozy from './components/NewsyDoozy';
import LoadingBar from 'react-top-loading-bar';

function App() {
  const [mode, setMode] = useState("primary");
  const [progress, setProgress] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  const toggleMode = () => {
    if (mode === "primary") {
      setMode("dark");
      document.body.style.backgroundColor = "#484747";
      document.body.style.color = "white";
    }
    else {
      setMode("primary");
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
    }
  }
  useEffect(() => {
    const storedName = sessionStorage.getItem('username');
    if (!storedName) {
      let name = '';
      while (!name || name.length > 17) {
        name = prompt('Please Enter Your Name (up to 17 characters):');
        if (name && name.length > 17) {
          alert('Please enter a name with up to 17 characters.');
        }
      }
      if (name) {
        const capitalizedFullName = name
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');

        sessionStorage.setItem('username', capitalizedFullName);
      }
    }
  }, []);

  const pageSize = 12;
  const apiKey = process.env.REACT_APP_NEWS_API_RAPID_API

  return (
    <>
      <Router>
        <Navbar mode={mode} toggleMode={toggleMode} selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage} />
        <LoadingBar
          color='#f11946'
          height={4}
          progress={progress}
        // onLoaderFinished={() => setProgress(0)}
        />
        <Routes>
          <Route path="/newsydoozy" element={<NewsyDoozy key="newsydoozy" tabTitle="original" borderColor={mode === "primary" ? "#007BFF" : "black"} mode={mode} />}></Route>
          <Route path="/" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="world/" tabTitle="original" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="world" />}></Route>
          <Route path="/home" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="worldhome" tabTitle="original" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="world" />}></Route>
          <Route path="/business" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="business" tabTitle="acctocategory" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="business" />}></Route>
          <Route path="/education" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="education" tabTitle="acctocategory" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="education" />}></Route>
          <Route path="/entertainment" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="entertainment" tabTitle="acctocategory" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="entertainment" />}></Route>
          <Route path="/health" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="health" tabTitle="acctocategory" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="health" />}></Route>
          <Route path="/science_and_technology" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="science" tabTitle="acctocategory" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="science_and_technology" />}></Route>
          <Route path="/sports" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="sports" tabTitle="acctocategory" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="sport" />}></Route>
          <Route path="/travel" element={<News setProgress={setProgress} apiKey={apiKey} mode={mode} key="travel" tabTitle="acctocategory" pageSize={pageSize} country="in" selectedLanguage={selectedLanguage} category="travel" />}></Route>
          <Route path="/about" element={<About mode={mode} />}></Route>
        </Routes>
      </Router>
    </>
  )
}

export default App;
